export const mgPlatformMenuIcon = {
  data: `<svg viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.74 8.56006H0.589966" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.74 4.56006H0.589966" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.74 0.560059H0.589966" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'menu'
}
